import React, { useEffect } from "react";

import Free_Consultation from "../../home/free-consultation/Free_Consultation";
import Inner_Page_Banner from "./inner-page-banner/Inner_Page_Banner";
import Include_Services from "./include-services/Include_Services";
import Key_Benefits from "./key-benefits/Key_Benefits";
import Rooftop_Solar from "./rooftop-solar/Rooftop_Solar";

const Service_Inner_Page = () => {

 

    return (
        <>
           
            <div >
                <Inner_Page_Banner />
            </div>

            
            <div >
                <Include_Services />
            </div>

          
            <div >
                <Key_Benefits />
            </div>

            
            <div >
                <Free_Consultation />
            </div>

           
            <div >
                <Rooftop_Solar />
            </div>
        </>
    );
};

export default Service_Inner_Page;